import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getTotalProductsShipped = {
  name: "getTotalProductsShipped" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
